module.exports = __webpack_public_path__ + "img/trend-down-01.1c30c5ca.svg";